import React from 'react';
import { GenericEntry } from '..';
import { Simple } from '../../../../entities/ApplicationFeed';
import { User } from '../../../../entities/User';
import { Application } from '../../../../entities/Application';
import { AuthorName } from '../AuthorName';
import { AlertObject } from '../../../../components/Alert';

interface PropTypes {
  application: Application;
  currentUser: User;
  entry: Simple;
  isLastItemInPage: boolean;
  setAlert: (data: AlertObject) => void;
  reloadFeed: () => void;
}

export function UnrejectionEntry(props: PropTypes) {
  return (
    <GenericEntry
      icon='bi-file-plus'
      iconClassName='bg-blue-gray-light'
      title={
        <>
          <AuthorName name={props.entry.authorName} /> unrejected{' '}
          <strong>{props.application.candidate.name}</strong> for the{' '}
          <strong>{props.application.job.name}</strong> job.
        </>
      }
      date={props.entry.createdAt}
      {...props}
    />
  );
}
